import {useTitle} from "../dashboard/TitleContext";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import * as React from "react";
import {useEffect, useState} from "react";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import {useSnackbar} from "../../util/SnackbarProvider";
import {useNavigate} from "react-router-dom";
import {Accordion, AccordionDetails, AccordionSummary, Button, Checkbox, CircularProgress, FormControlLabel, Grid2 as Grid, TextField, Tooltip} from "@mui/material";
import {Add, ArrowDropUp, Ballot, Delete, FilterAltOff, History, KeyboardArrowDown, MoveDown, Storage} from "@mui/icons-material";
import ConfirmationDialog from "../common/ConfirmationDialog";
import TablePagination from "@mui/material/TablePagination";
import FilterPanel from "../common/FilterPanel";
import productProjectService from "../../services/ProductProjectService";
import IconButton from "@mui/material/IconButton";
import {ArrowDropDownIcon} from "@mui/x-date-pickers";
import {useLocalNavigation} from "../dashboard/LocalNavigationContext";
import productService from "../../services/ProductService";

const ALL_COLUMNS = [
    {id: "identifier", label: "Projektszám", width: "60px"},
    {id: "name", label: "Név"},
    {id: "iterationCount", label: "Gyártási ciklusok száma"},
    {id: "createdAt", label: "Létrehozva", width: "150px"},
    {id: "updatedAt", label: "Módosítva", width: "150px"},
]

const DEFAULT_COLUMNS = ['identifier', 'name', 'iterationCount', 'createdAt', 'updatedAt'];

const LOCAL_STORAGE_ITEM_NAME = "product-project-rows-per-page"
const LOCAL_STORAGE_SEARCH_PARAMS = "product-project-search-params"
const LOCAL_STORAGE_COLUMN_NAMES = "product-project-column-names"
const DEFAULT_SEARCH_PARAMS = {}

export default function ProductProjects() {

    useTitle([{name: 'Termék Projektek'}])

    useLocalNavigation([
        {title: 'Alraktárak', url: '/dashboard/storage/substorages', icon: <Storage/>},
        {title: 'Termékek Mozgatása', url: '/dashboard/storage/move', icon: <MoveDown/>},
        {title: 'Raktár Történet', url: '/dashboard/storage/logs', icon: <History/>},
        {title: 'Feladatkörök', url: '/dashboard/task-types', icon: <Ballot/>},
    ])

    const {sendAlertMessage} = useSnackbar()
    const navigate = useNavigate();
    const [dialogState, setDialogState] = React.useState({open: false, object: null})
    const [tableData, setTableData] = useState({
        page: 0,
        rowsPerPage: localStorage.getItem(LOCAL_STORAGE_ITEM_NAME) || 25,
        totalCount: 0
    })
    const [searchParams, setSearchParams] = useState(JSON.parse(localStorage.getItem(LOCAL_STORAGE_SEARCH_PARAMS)) || DEFAULT_SEARCH_PARAMS)
    const [columnNames, setColumnNames] = React.useState(JSON.parse(localStorage.getItem(LOCAL_STORAGE_COLUMN_NAMES)) || DEFAULT_COLUMNS)
    const [expanded, setExpanded] = useState(true);
    const handleDeletionClick = (object) => setDialogState({open: true, object: object})
    const handleClose = () => setDialogState({open: false, object: null})
    const filterPanelRef = React.useRef();

    useEffect(() => {
            productService.findAllProductsToOrder()
                .then(response => console.log(response))
            retrieveProductProjects()
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [tableData.page, tableData.rowsPerPage, searchParams])

        const retrieveProductProjects = () => {
            productProjectService.search(buildQueryParams())
                .then(response => setTableData((prev) => ({
                    ...prev,
                    totalCount: response.totalElements,
                    rows: response.content
                })))
                .catch(error => sendAlertMessage(error?.message || "Termék projektek lekérése sikertelen", 'error'))
        }

        function buildQueryParams() {
            return {
                page: tableData.page,
                size: tableData.rowsPerPage,
                ...(searchParams?.identifier && {identifier: searchParams.identifier}),
                ...(searchParams?.name && {name: searchParams.name}),
                ...(searchParams?.orderBy && {orderBy: searchParams.orderBy}),
                ...(searchParams?.sort && {sort: searchParams.sort}),
            }
        }

        const deleteProductProject = (id) => {
            productProjectService.delete(id)
                .then(() => {
                    sendAlertMessage('Termék projekt sikeresen törölve')
                    retrieveProductProjects()
                })
            .catch(error => sendAlertMessage(error?.message || 'Termék projekt törlése sikertelen', 'error'))
    }

    const onSearchParamsChange = (event, n, v) => {
        let name = event?.target?.name || n
        let value = event?.target?.value || v
        setSearchParams((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const clear = () => {
        if (searchParams != null) sendAlertMessage('Szűrők alaphelyzetbe állítva', 'info')
        setSearchParams(DEFAULT_SEARCH_PARAMS)
        filterPanelRef.current?.resetSelection();
    }

    useEffect(() => {
        if (searchParams) localStorage.setItem(LOCAL_STORAGE_SEARCH_PARAMS, JSON.stringify(searchParams));
        else localStorage.removeItem(LOCAL_STORAGE_SEARCH_PARAMS)
    }, [searchParams]);

    const onChangeColumnCheckBox = (event) => {
        const {checked, name} = event.target;
        setColumnNames((prev) => {
            return checked ? prev.includes(name) ? prev : [...prev, name] : prev.filter((col) => col !== name);
        });
    };

    useEffect(() => {
        if (columnNames) localStorage.setItem(LOCAL_STORAGE_COLUMN_NAMES, JSON.stringify(columnNames));
        else localStorage.removeItem(LOCAL_STORAGE_COLUMN_NAMES)
    }, [columnNames]);

    const sortButton = (name) => {
        return (
            <IconButton onClick={() => setSearchParams(prev => ({
                ...prev,
                orderBy: name,
                sort: searchParams.sort === 'ASC' ? 'DESC' : 'ASC'
            }))}>
                {searchParams.sort == null || searchParams.orderBy !== name ?
                    <ArrowDropDownIcon sx={{color: "lightgray"}}/> :
                    searchParams.sort === 'ASC' ? <ArrowDropDownIcon/> : <ArrowDropUp/>}
            </IconButton>)
    }

    return (
        <>
            <Accordion style={{marginBottom: "10px"}} disableGutters expanded={expanded}
                       onChange={() => setExpanded(!expanded)}>
                <AccordionSummary
                    expandIcon={<KeyboardArrowDown sx={{marginRight: "0px", height: "2em", width: "auto"}}/>} sx={{
                    minHeight: "0px",
                    fontSize: "24px",
                    fontWeight: "bold",
                    backgroundColor: "darkgray",
                    borderRadius: "4px 4px 0px 0px",
                    paddingLeft: "20px",
                    margin: "0"
                }}>
                    Keresési Feltételek
                </AccordionSummary>
                <AccordionDetails className="filter-panel">
                    <Grid container columns={10} spacing={2} padding={"10px"}>
                        <Grid size={{xs: 7}}>
                            <Grid container columns={20} spacing={2} padding={"10px"}>


                                <Grid size={{xs: 20}}>
                                    {ALL_COLUMNS.map((item, index) => (
                                        <FormControlLabel
                                            key={index}
                                            control={<Checkbox
                                                variant="outlined"
                                                margin="normal"
                                                size="large"
                                                name={item.id}
                                                onChange={onChangeColumnCheckBox}
                                                checked={columnNames?.includes(item.id) || false}
                                                sx={{padding: "0px"}}
                                            />} label={item.label?.props?.title || item.label}
                                            style={{paddingRight: "20px", margin: "0px"}}/>
                                    ))}
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid size={{xs: 3}}>
                            <FilterPanel
                                type="PRODUCT_PROJECT"
                                ref={filterPanelRef}
                                currentSearchParams={searchParams}
                                onFilterSelect={(params) => setSearchParams(params)}
                            />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            <Paper sx={{width: '100%', overflow: 'hidden', fontSize: '10px'}}>
                <TableContainer>
                    <Table stickyHeader aria-label="sticky table" sx={{tableLayout: "fixed"}}>
                        <TableHead>
                            <TableRow>
                                <TableCell key="actions"
                                           style={{width: "100px", paddingLeft: "10px"}}
                                           align='left' padding='none'>
                                    <Tooltip title="Új hozzáadása">
                                        <Button variant='contained' color='success'
                                                sx={{minWidth: "0px", padding: "0px", marginRight: "10px"}}
                                                onClick={() => navigate("/dashboard/product-projects/create")}>
                                            <Add fontSize="large"/>
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title="Szűrők törlése">
                                        <Button variant='contained' color='info'
                                                sx={{minWidth: "0px", padding: "0px", marginRight: "10px"}}
                                                onClick={clear}>
                                            <FilterAltOff fontSize="large"/>
                                        </Button>
                                    </Tooltip>
                                </TableCell>
                                {columnNames.includes('identifier') &&
                                    <TableCell sx={{padding: "8px", width: "200px"}}>
                                        <TextField name="identifier" label="Projektszám" size="small"
                                                   value={searchParams.identifier || ""} onChange={onSearchParamsChange}
                                                   sx={{margin: "0px", width: "calc(100% - 40px)"}} autoComplete="off"/>
                                        {sortButton('identifier')}
                                    </TableCell>}
                                {columnNames.includes('name') &&
                                    <TableCell sx={{padding: "8px"}}>
                                        <TextField name="name" label="Név" size="small"
                                                   value={searchParams.name || ""} onChange={onSearchParamsChange}
                                                   sx={{margin: "0px", width: "calc(100% - 40px)"}} autoComplete="off"/>
                                        {sortButton('name')}
                                    </TableCell>}
                                {columnNames.includes('name') && <TableCell sx={{padding: "8px"}}>Gyártási ciklusok</TableCell>}
                                {columnNames.includes('createdAt') &&
                                    <TableCell sx={{padding: "8px"}}>
                                        Létrehozva
                                        {sortButton('createdAt')}
                                    </TableCell>}
                                {columnNames.includes('updatedAt') &&
                                    <TableCell sx={{padding: "8px"}}>
                                        Módosítva
                                        {sortButton('updatedAt')}
                                    </TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.rows == null ?
                                <TableRow sx={{textAlign: "center"}}>
                                    <TableCell colSpan={20} sx={{padding: "200px", textAlign: "center"}}>
                                        <CircularProgress/>
                                    </TableCell>
                                </TableRow> :
                                <>
                                    {tableData.rows?.map((pp, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell padding='none' align='center' sx={{
                                                display: "inline-flex",
                                                padding: "2px",
                                                width: "100%",
                                                height: "30px !important",
                                                justifyContent: "space-between"
                                            }}>
                                                <Tooltip title={"Törlés"} placement="left">
                                                    <Delete onClick={() => handleDeletionClick(pp)} sx={{
                                                        position: "relative",
                                                        top: "3px",
                                                        left: "0px",
                                                        width: "24px",
                                                        color: "#808080",
                                                        cursor: "pointer"
                                                    }}/>
                                                </Tooltip>
                                            </TableCell>
                                            {ALL_COLUMNS.filter(c => columnNames.includes(c.id)).map((column, index) => (
                                                <TableCell onClick={() => {
                                                    navigate(`/dashboard/product-projects/${pp.id}`)
                                                }}
                                                           sx={{
                                                               cursor: "pointer",
                                                               padding: "0px 5px",
                                                               whiteSpace: "nowrap",
                                                               textOverflow: "ellipsis",
                                                               overflow: "hidden",
                                                               textAlign: column.align
                                                           }}
                                                           key={index}>{column.fun ? column.fun(pp[column.id], pp) : pp[column.id]}</TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </>}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[3, 10, 25, 50]}
                    component="div"
                    count={tableData.totalCount}
                    rowsPerPage={parseInt(tableData.rowsPerPage)}
                    page={tableData.page}
                    onPageChange={(event, newPage) => setTableData((prev) => ({...prev, page: newPage}))}
                    onRowsPerPageChange={(event) => {
                        setTableData((prev) => ({...prev, rowsPerPage: event.target.value, page: 0}))
                        localStorage.setItem(LOCAL_STORAGE_ITEM_NAME, event.target.value)
                    }}
                    labelRowsPerPage="Elemek oldalanként:"
                />
            </Paper>

            <ConfirmationDialog
                title={"Biztosan törölni szeretnéd ezt a termék projektet?"}
                content={
                    <>
                        {dialogState.object?.name} <br/>
                    </>
                }
                open={dialogState.open}
                onClose={handleClose}
                onConfirm={() => {
                    deleteProductProject(dialogState.object?.id)
                }}
            />
        </>
    )
}